import {useState} from 'react'
import {createTheme} from '@mui/material/styles'
import {blue, blueGrey} from '@mui/material/colors'

const defaultTheme = {
  typography: {
    fontFamily: ['proxima_nova_regular'],
  },
}

export function useTheme() {
  const [currentTheme, setCurrentTheme] = useState({
    palette: {
      primary: blue,
      secondary: blueGrey,
    },
  })
  const muiTheme = createTheme({
    ...defaultTheme,
    ...currentTheme,
  })
  return [muiTheme, setCurrentTheme]
}
